import { IEventHistory } from "src/models/History";
import { toEventHistoryItem } from "../to-event-history-item";

export function toPalletTransferEventHistoryItem(data: IEventHistory) {
  const row = toEventHistoryItem(data);
  row.skuGroupsTransferredIn = data.skuGroupsTransferredIn;
  row.skuGroupsTransferredOut = data.skuGroupsTransferredOut;
  row.originCrate = data.originCrate;
  row.destinationCrate = data.destinationCrate;

  const transferred = (data.skuGroupsTransferredIn?.length ? data.skuGroupsTransferredIn : data.skuGroupsTransferredOut) || [];

  row.transferData = transferred.map(item => ({
    sku: item?.sku || '---',
    name: item?.name || '---',
    quantity: item?.quantity || '---',
  }));

  return row;
}
